import SettingsIcon from './SettingsIcon'

export default SettingsIcon
